import profileApiService from "../../services/api/ProfileApiService";
import profileService from "../../services/ProfileService";
export default {
  FETCH_MY_PROFILE: function FETCH_MY_PROFILE(_ref, success) {
    var commit = _ref.commit;
    commit("FETCH_MY_PROFILE", "FETCHING");
    profileApiService.me().then(function (myProfile) {
      commit("FETCH_MY_PROFILE", myProfile);
      if (success) success(myProfile);
    }).catch(function (err) {
      commit("FETCH_MY_PROFILE", err);
    });
  },
  FETCH_MANAGED_PROVIDERS: function FETCH_MANAGED_PROVIDERS(_ref2) {
    var commit = _ref2.commit;
    commit("FETCH_MANAGED_PROVIDERS", "FETCHING");
    profileApiService.managedProviders().then(function (managedProviders) {
      return commit("FETCH_MANAGED_PROVIDERS", managedProviders);
    }).catch(function (err) {
      return commit("FETCH_MANAGED_PROVIDERS", err);
    });
  },
  SELECT_PROVIDER: function SELECT_PROVIDER(_ref3, payload) {
    var commit = _ref3.commit;
    profileService.selectProvider(payload);
    commit("SELECT_PROVIDER", payload);
  }
};